import { render } from "./skulist.vue?vue&type=template&id=d51e2ef6"
import script from "./skulist.vue?vue&type=script&lang=js"
export * from "./skulist.vue?vue&type=script&lang=js"

import "./skulist.vue?vue&type=style&index=0&id=d51e2ef6&lang=less"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__